import type { RouteRecordRaw } from 'vue-router';

const MainLayout = () => import('@/shared/layouts/pages/MainLayout/index.vue');
const Profile = () => import('../pages/Profile/index.vue');
const ProfileSuccess = () => import('../pages/ProfileSuccess/index.vue');

export const profileRoutes: Array<RouteRecordRaw> = [
  {
    path: '/profile',
    name: 'profile',
    component: MainLayout,
    meta: {
      accessRol: {
        section: 'PROFILE',
        actions: ['USER', 'SECURITY'],
      },
    },
    children: [
      {
        path: ':tab',
        name: 'profile-index',
        component: Profile,
        props: true,
        meta: {
          title: 'Perfil',
        },
      },
      {
        path: '/success',
        name: 'profile-success',
        component: ProfileSuccess,
      },
    ],
  },
];
